<template>
  <article id="portfolio">
    <h1>portfolio</h1>
    <section>
        The following are {{ inWords(Object.keys(portfolioJson).length) }} <span class="red">projects</span> I have been working on.
        <div v-for="(data, index) in portfolioJson" :key="data.title">
          <a :href="'#project' + index" class="no-decoration">
            <span class="small-project" :style="{ background: 'url(' + require('../assets/img_pattern.webp') + ') repeat, url(' + require('../assets/' + data.image) + ') center center no-repeat' }">
              <span>{{ data.title }}</span>
            </span>
          </a>
        </div>
    </section>
    <!-- The following can be used to un/escape html for entry texts -->
    <!-- https://www.freeformatter.com/json-escape.html -->
    <template v-for="(data, index) in portfolioJson">
        <h2 :id="'project' + index" :key="data.title">{{ data.title }}</h2>
        <section :key="data.text">
            <div class="project" :style="{ background: 'url(' + require('../assets/img_pattern.webp') + ') repeat, url(' + require('../assets/' + data.image) + ') center center no-repeat' }"></div>
            <span v-html="data.text"></span>
        </section>
    </template>
  </article>
</template>

<script>
import json from '../portfolio.json'
export default {
  name: 'Portfolio',
  data () {
    return {
      portfolioJson: json
    }
  },
  methods: {
    inWords (num) {
      var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen ']
      var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']
      if ((num = num.toString()).length > 9) return 'overflow'
      var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/)
      if (!n) return; var str = ''
      // eslint-disable-next-line
      str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : ''
      // eslint-disable-next-line
      str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : ''
      // eslint-disable-next-line
      str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : ''
      // eslint-disable-next-line
      str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : ''
      // eslint-disable-next-line
      str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : ''
      return str
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../variables.scss';

.project {
  background-attachment: scroll, fixed !important;
  background-size: auto, cover !important;
  display: block;
  width: calc(100% + 100px);
  height: 200px;
  margin: -80px -50px 50px -50px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.small-project {
  background-attachment: scroll, fixed !important;
  background-size: auto, cover !important;
  padding: 10px;
  margin: 20px 0 20px 0;
  font-weight: bold;
  display: block;
  text-align: center;
  text-shadow: 0px 0px 5px black;
  border-radius: 3px;
}
.no-decoration {
  text-decoration: none !important;
}
a:any-link .small-project {
  color: $white;
  text-decoration-color: $white;
}
a:hover .small-project {
  text-decoration: underline;
}

section {
    margin-bottom: 30px;
}

h2:nth-child(n) {
    bottom: -120px !important;
}

h2 {
    font-family: 'Roboto', sans-serif;
    font-size: 2em;
    position: relative;
    mix-blend-mode: difference;
    float: left;
    display: inline;
    margin: 0px 0px 0px 50px;
    bottom: -180px;
}

</style>
